var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84476 16.5797C8.22696 16.896 8.60238 17.1933 8.96173 17.4687C10.2937 18.4896 10.9597 19 12 19C13.0403 19 13.7063 18.4896 15.0383 17.4688C17.9806 15.2138 22 11.4887 22 7.9665C22 2.08262 16.4998 -0.114139 12 4.43111C7.50016 -0.114139 2 2.08262 2 7.96653C2 9.93655 3.2575 11.9701 4.88066 13.7744C4.74761 15.893 3.96279 17.5074 2.11653 18.5716C1.89266 18.7006 2.01672 19.0418 2.27392 18.9958C5.40557 18.4347 6.91563 17.6443 7.84476 16.5797ZM8 11C7.44772 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11ZM12 11C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.5523 12.5523 11 12 11ZM17 10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10C15 9.44772 15.4477 9 16 9C16.5523 9 17 9.44772 17 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble37);
export default __webpack_public_path__ + "static/media/speech-bubble-37.5e61e9388a2178d8bf43319c1e3109b8.svg";
export { ForwardRef as ReactComponent };